


















import {
  Vue, Component, Prop, Emit, Watch, Model,
} from 'vue-property-decorator';
import { Form } from 'element-ui';

@Component({
  name: 'NewForm',
})
export default class NewForm extends Vue {
  @Prop({ default: 'Tạo mới' }) public submitText!: string;

  @Model('change', { required: true }) public form!: {[key: string]: any};

  @Watch('form', { deep: true })
  protected onFormChange(value: any) {
    this.$emit('change', value);
  }

  private get parsedFormArray(): Array<string[]> {
    if (!this.form) return [['', '']];
    return Object.entries(this.form);
  }

  private onSubmit() {
    (this.$refs.form as Form).validate((isValid: boolean) => {
      if (isValid) {
        this.$emit('submit');
      }
    });
  }
}
